import { useEffect, useRef } from "react";
import { Button, notification } from "antd";
import { useTranslation } from "react-i18next";

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export function useAppVersionCheck() {
  const { t } = useTranslation();
  const tRef = useRef(t);
  const baselineRef = useRef(null);
  const notifiedRef = useRef(false);

  // Keep tRef current without re-running the polling effect on language change
  useEffect(() => {
    tRef.current = t;
  });

  useEffect(() => {
    const fetchManifest = async () => {
      try {
        const res = await fetch("/asset-manifest.json", {
          cache: "no-cache",
          headers: { "Cache-Control": "no-cache" },
        });
        if (!res.ok) return null;
        return await res.text();
      } catch {
        return null;
      }
    };

    const checkVersion = async () => {
      const manifest = await fetchManifest();
      if (!manifest) return;

      if (baselineRef.current === null) {
        baselineRef.current = manifest;
        return;
      }

      if (manifest !== baselineRef.current && !notifiedRef.current) {
        notifiedRef.current = true;
        notification.warning({
          message: tRef.current("notifications.newVersionAvailable"),
          description: tRef.current("notifications.newVersionDescription"),
          duration: 0,
          key: "app-version-update",
          btn: (
            <Button type="primary" size="small" onClick={() => window.location.reload()}>
              {tRef.current("notifications.reload")}
            </Button>
          ),
        });
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
